import { render } from "./MenuPro.vue?vue&type=template&id=3611518e&scoped=true"
import script from "./MenuPro.vue?vue&type=script&lang=js"
export * from "./MenuPro.vue?vue&type=script&lang=js"

import "./MenuPro.vue?vue&type=style&index=0&id=3611518e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3611518e"]])

export default __exports__